import { useAuthControllerMe } from '@werkbank/shared';

/**
 * Prüft, ob der angemeldete Nutzer einen Permission-Flag hält (A2-1). Rollen der
 * Administrator-Klasse halten implizit alle Flags; sonst zählt der gespeicherte
 * Flag. Serverseitig ist der Guard maßgeblich — dieses Hook blendet nur
 * Bedienelemente aus, für die der Nutzer ohnehin ein 403 bekäme.
 */
export function useHasFlag(flag: string): boolean {
  const me = useAuthControllerMe();
  const u = me.data;
  if (!u) return false;
  if (u.roleIsAdmin) return true;
  return (u.permissions as Record<string, boolean> | undefined)?.[flag] === true;
}
